import { render, staticRenderFns } from "./setSystem.vue?vue&type=template&id=ad5d1894&scoped=true"
import script from "./setSystem.vue?vue&type=script&lang=js"
export * from "./setSystem.vue?vue&type=script&lang=js"
import style0 from "./setSystem.vue?vue&type=style&index=0&id=ad5d1894&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5d1894",
  null
  
)

export default component.exports